import {
  CompositionPickAction,
  CompositionPicks,
  CompositionSide,
  FurnaceFuel
} from './system-composition-types';

export const selectedFuelForSide = (
  picks: CompositionPicks,
  side: CompositionSide
): FurnaceFuel | null =>
  side === 'split' ? picks.blowerFuel : picks.packagedFuel;

export const fuelActionForSide = (
  side: CompositionSide,
  fuel: FurnaceFuel
): CompositionPickAction =>
  side === 'split'
    ? { slot: 'blower-fuel', fuel }
    : { slot: 'packaged-fuel', fuel };

export const isFuelPickAction = (action: CompositionPickAction): boolean =>
  action.slot === 'blower-fuel' || action.slot === 'packaged-fuel';

export const actionSide = (action: CompositionPickAction): CompositionSide =>
  action.slot === 'packaged-cooling' ||
  action.slot === 'packaged-heating' ||
  action.slot === 'packaged-fuel'
    ? 'packaged'
    : 'split';

export const fuelPickerLabelForSide = (side: CompositionSide): string =>
  side === 'split' ? 'Fuel type' : 'Packaged unit fuel type';
